import React from 'react'
import {
  AppDialog,
  AppDialogBody,
  AppDialogContent,
  AppDialogDescription,
  AppDialogFooter,
  AppDialogHeader,
  AppDialogTitle,
} from '@easyllama/ui-components'
import AddNewLearnerKioskForm from '~/molecules/PublicKiosk/AddNewLearnerKioskForm'
import { PH_NO_CAPTURE_CLASS } from '~/service/constants'

const AddNewLearnerKioskDialog = ({ open, secretId, companyId, trainingId, formMetadata, onOpenChange }) => (
  <AppDialog open={open} onOpenChange={onOpenChange}>
    <AppDialogContent>
      <AppDialogHeader>
        <AppDialogTitle>Add Learner</AppDialogTitle>
        <AppDialogDescription>Please enter your details to start a new training.</AppDialogDescription>
      </AppDialogHeader>
      <AppDialogBody className={PH_NO_CAPTURE_CLASS}>
        <AddNewLearnerKioskForm
          secretId={secretId}
          companyId={companyId}
          trainingId={trainingId}
          formMetadata={formMetadata}
          onClose={() => onOpenChange(false)}
        />
      </AppDialogBody>
      <AppDialogFooter className='h-12.5' />
    </AppDialogContent>
  </AppDialog>
)

export default AddNewLearnerKioskDialog
